export enum FormType {
  LoginFirstPhone = "login-first-phone",
  LoginFirstEmail = "login-first-email",
  LoginSecondPhone = "login-second-phone",
  LoginSecondEmail = "login-second-email",
  LoginCertificate = "login-certificate",
  LoginCertificateCheck = "login-certificate-check",
  LoginBlockMob = "login-mob-block",
  Registration = "registration",
  RegistrationDetail = "registration-detail",
  LoginInn = "login-inn",
  LoginType = "login-type",
  LoginClientOrAgent = "login-client-or-agent",
  LoginCheckEmail = "login-check-email",
}

export enum productsId {
  credits = 1000,
  factoring = 1001,
  rko = 1002,
  bankovskiye_garantii = 1003,
  lizing = 1004,
  otkritie_raschetnogo_scheta = 1005,
  potrebcredits = 1006,
  creditcard = 1007,
  ipoteka = 1008,
}